export default "__VITE_ASSET__142a65b6__"